/**
 * REMOVES EMPTY OR UNDEFINED KEYS FROM AN OBJECT
 * @param params
 * @returns
 */
export const filterParams = (params: any) => {
    Object.keys(params).forEach((key: any) => {
        if (!params[key] || params[key].length === 0) {
            if (typeof params[key] === 'undefined') {
                params[key] = ''
            } else if (params[key] === false) {
                params[key] = false
            } else {
                delete params[key]
            }
        }
    })
    return params
}

/**
 *
 * @param variable
 * @returns
 */
const filterVariable = (variable: any) => {
    if (!variable || variable.length === 0) {
        if (typeof variable === 'undefined') {
            return ''
        } else if (variable === false || variable === 0) {
            return 0
        }
    }

    return variable
}

/**
 * CREATES FORM DATA FROM ANY OBJECT B)
 * @param values
 * @returns
 */
export const setFormData = (values: any) => {
    const fd = new FormData()

    const setFdArray = (array: Array<any>, oldKey: string) => {
        array.forEach((item) => {
            if (!(item instanceof File) && typeof item === 'object') {
                setFdObject(item, `${item}[]`)
            } else if (item instanceof Array) {
                setFdArray(item, '[]')
            } else {
                fd.append(`${oldKey}[]`, filterVariable(item))
            }
        })
    }

    const setFdObject = (newValues: any, oldKey: string) => {
        if (newValues) {
            Object.keys(newValues).forEach((key) => {
                if (
                    !(newValues[key] instanceof File) &&
                    typeof newValues[key] === 'object'
                ) {
                    setFdObject(newValues[key], `${oldKey}[${key}]`)
                } else {
                    fd.append(
                        `${oldKey}[${key}]`,
                        filterVariable(newValues[key])
                    )
                }
            })
        }
    }

    if (values) {
        Object.keys(values).forEach((key) => {
            if (
                !(values[key] instanceof File) &&
                typeof values[key] === 'object'
            ) {
                setFdObject(values[key], key)
            } else if (values[key] instanceof Array) {
                setFdArray(values[key], key)
            } else {
                fd.append(key, filterVariable(values[key]))
            }
        })
    }
    return fd
}
